/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for get bank account
 * @export
 * @interface BankAccountResponse
 */
export interface BankAccountResponse {
    /**
     * Unique identifier of the financial channel
     * @type {number}
     * @memberof BankAccountResponse
     */
    id?: number;
    /**
     * the code bic of bank
     * @type {string}
     * @memberof BankAccountResponse
     */
    bic?: string;
    /**
     * the iban of bank account
     * @type {string}
     * @memberof BankAccountResponse
     */
    iban?: string;
    /**
     * Indicate if the appointment type is active
     * @type {boolean}
     * @memberof BankAccountResponse
     */
    active?: boolean;
    /**
     * True if the bank account can be edited
     * @type {boolean}
     * @memberof BankAccountResponse
     */
    editable?: boolean;
}

/**
 * Check if a given object implements the BankAccountResponse interface.
 */
export function instanceOfBankAccountResponse(value: object): value is BankAccountResponse {
    return true;
}

export function BankAccountResponseFromJSON(json: any): BankAccountResponse {
    return BankAccountResponseFromJSONTyped(json, false);
}

export function BankAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'active': json['active'] == null ? undefined : json['active'],
        'editable': json['editable'] == null ? undefined : json['editable'],
    };
}

export function BankAccountResponseToJSON(json: any): BankAccountResponse {
    return BankAccountResponseToJSONTyped(json, false);
}

export function BankAccountResponseToJSONTyped(value?: BankAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'bic': value['bic'],
        'iban': value['iban'],
        'active': value['active'],
        'editable': value['editable'],
    };
}

